import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LogoMain from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';

export default function LogoSection({ isIcon, sx, to }) {
  return (
    <Link to={to || APP_DEFAULT_PATH} style={{ display: 'inline-flex', alignItems: 'center', ...sx }}>
      {isIcon ? <LogoIcon /> : <LogoMain />}
    </Link>
  );
}

LogoSection.propTypes = { isIcon: PropTypes.bool, sx: PropTypes.object, to: PropTypes.any };
